import "./LoaderSimple.scss"

const LoaderSimple = () => <span className='LoaderSimple' />

export default LoaderSimple
